import { Link } from 'react-router-dom';
import './HowItWorks.css';
import hiwBg from '../../assets/hiw_means_house2.png';
import icon1 from '../../assets/figma_hiw_icon1.svg';
import icon2 from '../../assets/figma_hiw_icon2.svg';
import icon3 from '../../assets/figma_hiw_icon3.svg';
import checkDecagram from '../../assets/figma_check_decagram.svg';
import savesUnderline from '../../assets/figma_saves_underline.svg';

const steps = [
  {
    icon: icon1,
    title: 'Make Your Own Power',
    desc: 'Your solar panels generate electricity during the day, straight from the sun',
  },
  {
    icon: icon2,
    title: 'Store It for Later',
    desc: 'Any extra power gets stored in your battery, ready for when you need it',
  },
  {
    icon: icon3,
    title: 'Use It Anytime',
    desc: 'Use your stored energy at night, on cloudy days, or whenever prices spike',
  },
];

const benefits = [
  'Pay less on your electricity bills',
  'Depend less on your energy provider',
  'Stay in control, even when prices go up',
];

export default function HowItWorks() {
  return (
    <section className="how-it-works">
      <div className="how-inner">
        <h2 className="how-title">
          How it works and why it{' '}
          <span className="how-title-accent">
            saves you money
            <img src={savesUnderline} alt="" className="saves-stroke" />
          </span>
        </h2>
        <p className="how-subtitle">
          It's simpler than you think: generate your own power, store it, and use it whenever you need it.
        </p>

        <div className="how-steps">
          {steps.map((step, i) => (
            <div key={i} className="how-step">
              <div className="how-step-icon-wrap">
                <img src={step.icon} alt={step.title} className="how-step-icon" />
              </div>
              <h3 className="how-step-title">{step.title}</h3>
              <p className="how-step-desc">{step.desc}</p>
            </div>
          ))}
        </div>

        <div className="how-means-card">
          <div className="how-means-left">
            <h3 className="how-means-title">What this means for you</h3>
            <ul className="how-means-list">
              {benefits.map((b, i) => (
                <li key={i} className="how-means-item">
                  <img src={checkDecagram} alt="check" className="how-means-check" />
                  <span>{b}</span>
                </li>
              ))}
            </ul>
            <Link to="/contact" className="how-cta-btn">
              Get free quote
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M5 12h14M12 5l7 7-7 7" stroke="#050b14" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </Link>
          </div>
          <div className="how-means-right" style={{ backgroundImage: `url(${hiwBg})` }} />
        </div>
      </div>
    </section>
  );
}
